module.exports = __webpack_public_path__ + "static/media/Project1_IntroImg4.8b3f048c.svg";